var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNohall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579.49 106.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f8f9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "77.76 103.02 78.15 2.89 73.89 2.88 73.53 94.6 3.57 2.6 0.39 2.59 0 102.72 4.26 102.74 4.62 11.14 74.45 103.01 77.76 103.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156,0h-.24a51.6,51.6,0,0,0-37.57,15.44A51.42,51.42,0,0,0,102.46,53a51.58,51.58,0,0,0,15.43,37.8,51.6,51.6,0,0,0,37.68,15.73h.24a51.46,51.46,0,0,0,37.44-15.43A51.64,51.64,0,0,0,209,53.41a51.51,51.51,0,0,0-15.44-37.68A51.48,51.48,0,0,0,156,0Zm34.26,88.07a47.32,47.32,0,0,1-34.44,14.19h-.22A47.51,47.51,0,0,1,120.91,87.8,47.49,47.49,0,0,1,106.72,53a47.31,47.31,0,0,1,14.46-34.55,47.48,47.48,0,0,1,34.57-14.2H156a47.34,47.34,0,0,1,34.55,14.47,47.37,47.37,0,0,1,14.2,34.66A47.52,47.52,0,0,1,190.25,88.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "314.24 103.95 314.63 3.81 310.37 3.8 310.18 51.73 237.75 51.45 237.93 3.52 233.67 3.5 233.28 103.63 237.54 103.65 237.73 55.71 310.17 55.99 309.98 103.93 314.24 103.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "386.67 4.1 381.88 4.08 334.76 104.03 339.49 104.04 348.97 83.84 384.25 9.2 418.95 84.11 420.93 88.38 428.28 104.39 433.13 104.41 386.67 4.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "454.17 4.36 453.78 104.49 509.17 104.71 509.19 100.44 458.06 100.25 458.43 4.38 454.17 4.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "524.48 4.63 524.09 104.76 579.48 104.98 579.49 100.72 528.36 100.52 528.74 4.65 524.48 4.63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNohall);
export default __webpack_public_path__ + "static/media/Logo-nohall.f86021e2e92c4f80d45e50350e4977dc.svg";
export { ForwardRef as ReactComponent };